/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 27/01/22
 */

import { useContext } from 'react';
import { WorkplanContext } from '@/components/contexts/WorkplanContext/WorkplanProvider';

export const useWorkplan = () => {
    return useContext(WorkplanContext);
};
